import styled from 'styled-components'
import { EInstitutionMediaType } from '@ucheba/store/institutions/item/types'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'

import IconExpand from '@ucheba/ui/icons/icon__expand.svg'
import { Button } from '@ucheba/ui/components/Button/desktop'

import GalleryItem from '../../components/GalleryItem'

import { ILightGalleryProps, IPhotosItemProps } from '../../types'

export const ShowAllButton = styled(Button)`
  position: absolute;
  z-index: 22;
  right: 12px;
  bottom: 12px;
  padding: 0 12px;

  ${sm.breakpoint.lgAndUp`
    width: 172px
  `};

  ${sm.breakpoint.lgAndDown`
    width: 160px;
  `};
`

export const GridContainer = styled.div`
  position: relative;
  width: 100%;
  height: 360px;
  background: ${sv.color.gray5};
  border-radius: 8px;
`

export const IconExpandStyled = styled(IconExpand)`
  width: 20px;
  height: 20px;
`

export const PhotosItem = styled(GalleryItem)<IPhotosItemProps>`
  grid-area: ${({ gridArea }) => gridArea};

  background-image: ${({ thumb }) => thumb?.fallbackUrl && `url(${thumb?.fallbackUrl})`};
  background-size: cover;
  background-position: center;
  position: relative;

  &::before {
    content: '';
    background-image: ${({ mediaType }) =>
      mediaType !== EInstitutionMediaType.photo
        ? "url('/static/img/video-covers/icon__circled-play.svg')"
        : ''};
    background-size: cover;
    background-position: center;
    opacity: 0.6;
    width: 58px;
    height: 58px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  img {
    display: none;
  }
`
export const PhotosSC = styled.div<ILightGalleryProps>`
  width: 100%;
  height: 360px;
  display: grid;
  grid-template-areas: ${({ gridTemplateAreas }) => gridTemplateAreas};
  overflow: hidden;
  position: relative;
`
export const Photos = styled(PhotosSC)`
  grid-area: ${({ gridArea }) => gridArea};
  border-radius: 8px;

  a:nth-child(n + 6) {
    display: none;
  }
`
